import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css';
import './index.css';
import './attention.css';
import './onboarding.css';
import './product-demo.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {LanguageProvider} from './localization';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider><App /></LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
